import { Steps } from "antd";
import styled from "styled-components";

export const StepWrapper = styled.div`
  
  width: 100%;
  overflow: hidden;

  
`;

export const CustomSpan = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #42005a;
  font-family: 'QuickSand','Verdana', sans-serif;
  
`

export const SpanLined = styled.span`
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 1rem;
  align-items: center;
  font-size: 16px;
  font-style: italic;
  font-weight: bold;
  color: #42005a;
  margin-top: 30px;
  margin-bottom: 10px;

  
  &::after {
    content: "";
    height: 1px;
    display: block;
    background-color: #42005a;
  }
`;

export const StyledSteps = styled(Steps)`
  && {
    .ant-steps-item-title {
      font-size: 12px;
      
    }

    
  }

&& {
  .ant-steps-item-finish .ant-steps-item-container .ant-steps-item-content .ant-steps-item-title{
      color: #42005a;
      font-weight: 500;
    }
}

&& {
  .ant-steps-item-process .ant-steps-item-container .ant-steps-item-content .ant-steps-item-title{
      color: #42005a;
      font-weight: 500;
    }
}



  overflow-x: auto;


  &::-webkit-scrollbar {
    height: 16px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #42005a;
    border-radius: 4px;
    &:hover {
      background-color:rgb(112, 50, 134);
    }
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }

  scrollbar-width: thin;
  scrollbar-color: #42005a #f1f1f1;
`;
